import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router, CanActivateChild } from '@angular/router';

import { DataMaterialsService } from '@components/materials/data-materials.service';
import { GlobalDataService } from '@providers/global-data/global-data.service';
import { DASHBOARD_ROUTES } from '@providers/routes-config';

@Injectable({
  providedIn: 'root'
})
export class MaterialsGuard implements CanActivateChild {
  constructor(
    private globalDataService: GlobalDataService,
    private dataMaterialsService: DataMaterialsService,
    private router: Router
  ) {}

  async canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    const match = state.url.match(/^\/projects\/(\d+)\/materials/);

    let canActivate = true;

    if (match !== null) {
      await this.globalDataService.getCurrentProject().subscribe(async (project) => {
        this.dataMaterialsService.currentProject = project;

        await this.dataMaterialsService.computeProjectMaterialsData();

        if (!this.dataMaterialsService.hasProjectMaterials()) {
          canActivate = false;
        }
      });
    }

    if (!canActivate) {
      this.router.navigate([DASHBOARD_ROUTES.GET.dashboard.replace(':pid', match[1])]);
    }

    return canActivate;
  }
}
